import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import ShiftTimePicker from '../ShiftTimePicker';
import { CreateAttendanceDepartment } from '../../../../../../../reduxToolkit/EmployeePayRoll/EmployeePayRollApi';
import CustomModal from '../../../../../../../components/Modal/CustomModal';
import { CleanIcon } from '../../../../../../../components/buttons/IconButtons';
import ButtonIcon from '../../../../../../../components/buttons/ButtonIcon';
import { errorMsg } from '../../../../../../../Apis/functions';
import { DEPARTMENT_POLICY_MODEL } from '../../../Model/Model';
import HandleChange from '../../../../../../../Helpers/HandleChange';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @param show - Boolean to determine if the "Add New Workshift" modal should be shown
 * @param onHide - Function to hide the modal when triggered
 * @param setModified - Function to set the created status flag after adding a new workshift
 */
const AddNewWorkshift = ({ show, onHide, setModified, departmentId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [selectedList, setSelectedList] = useState([]);
    const [emptyFields, setEmptyFields] = useState(false);
    const [item, setItem] = useState({ ...DEPARTMENT_POLICY_MODEL });
    const { handleChange : baseHandleChange } = HandleChange({ model: item, setModel: setItem });

    //handle create new workshift
    const handleCreate = () => {
        if (!item.isValid()) {
            setEmptyFields(true);
            return;
        }
        const supervisorIds = selectedList.map((s) => s.userId);

        const body = {
            ...item.toAddEdit(supervisorIds),
            departmentId: item?.departmentId,
        };

        dispatch(CreateAttendanceDepartment(body)).then(
            ({
                payload: {
                    data: { success, code },
                },
            }) => {
                if (success === true) {
                    setModified(true);
                    setItem({ ...DEPARTMENT_POLICY_MODEL });
                    setSelectedList([]);
                    onHide();
                    toast.success(t('has_been_created_successfully'));
                } else errorMsg(code);
            },
        );
    };
    // Clear all form fields and reset role state
    const clearField = () => {
        setItem({ ...DEPARTMENT_POLICY_MODEL });
        setSelectedList([]);
        setEmptyFields(false);
    };

    const handleChange = (e) => {
    const { name, value } = e.target;

    baseHandleChange({
        target: {
            name,
            value: item.normalizeValue(name, value),
        },
    });
};
    return (
        <CustomModal
            show={show}
            onHide={onHide}
            onConfirm={handleCreate}
            title='create'
            size='lg'
            buttonConfirm='confirm'
            cancelButton={true}
            confirmButton={true}
            classNameBody="pt-2"
        >
            <div className='d-flex justify-content-end mb-3'>
                <ButtonIcon
                    className='btn-clean-secondary-600'
                    id='btn_cnr_clean'
                    Icon={CleanIcon}
                    iconProps='btn-icon-svg-12px icon-color-general-00'
                    title={'clear_instances'}
                    onClick={clearField}
                />
            </div>
            <div className='row px-0'>
                <ShiftTimePicker
                    item={item}
                    displayNone={departmentId === null}
                    emptyFields={emptyFields}
                    handleChange={handleChange}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                />
            </div>
        </CustomModal>
    );
};

export default AddNewWorkshift;
